export enum InfoGridTypes {
    Contacts = 'Contacts',
    Addresses = 'Addresses',
    BankAccounts = 'BankAccounts',
    Documents = 'Documents',
}

export enum TxGridTypes {
    Orders = 'Orders',
    Deliveries = 'Deliveries',
    Invoices = 'Invoices',
}
